import { combineReducers } from "redux";

import historicSales from "./historicSales";

const reducer = combineReducers({
    historicSales
});

export default reducer;
